import {
    FC,
    Fragment,
    PropsWithChildren,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import classNames from 'classnames';

import { BottomSheetContext, BottomSheetData } from './BottomSheet.context';

type BottomSheetProviderProps = PropsWithChildren<{}>;

export const BottomSheetProvider: FC<BottomSheetProviderProps> = ({
    children,
}) => {
    const [isVisible, setIsVisible] = useState(false);

    const bottomSheetDataRef = useRef<BottomSheetData | null>(null);

    const contextValue = useMemo(() => {
        return {
            isVisible,
            bottomSheetData: bottomSheetDataRef.current,
            showBottomSheet: (data: BottomSheetData) => {
                bottomSheetDataRef.current = data;

                setIsVisible(true);
            },
            hideBottomSheet: () => setIsVisible(false),
        };
    }, [isVisible]);

    return (
        <BottomSheetContext.Provider value={contextValue}>
            {children}
            <div
                onClick={contextValue.hideBottomSheet}
                style={{ zIndex: 98 }}
                className={classNames(
                    'fixed w-full z-40 left-0 top-0 h-full bg-black/15 transition-opacity duration-300',
                    {
                        'opacity-0 pointer-events-none': !isVisible,
                    },
                )}
            />
            <div
                style={{ zIndex: 99 }}
                className={classNames(
                    'fixed w-full z-50 left-0 right-0 min-h-24 rounded-t-lg bg-white shadow-lg transition-all duration-300',
                    {
                        'bottom-0': isVisible,
                        '-bottom-full pointer-events-none': !isVisible,
                    },
                )}>
                <Fragment key={bottomSheetDataRef.current?.id}>
                    {bottomSheetDataRef.current?.content}
                </Fragment>
            </div>
        </BottomSheetContext.Provider>
    );
};
